import { blend, clamp } from './interpolate';

const scoreCategoryMix = (share) => {
  if (share >= 0.8) return 90 + ((share - 0.8) / 0.2) * (95 - 90);
  if (share >= 0.5) return 65 + ((share - 0.5) / 0.3) * (90 - 65);
  if (share >= 0.2) return 40 + ((share - 0.2) / 0.3) * (65 - 40);
  return clamp(40 - (0.2 - share) * 100, 15, 40);
};

const scoreExempt = (share) => {
  if (share <= 0.05) return 90;
  if (share <= 0.15) return 90 - ((share - 0.05) / 0.1) * (90 - 60);
  if (share <= 0.3) return 60 - ((share - 0.15) / 0.15) * (60 - 35);
  return clamp(35 - (share - 0.3) * 100, 15, 35);
};

const scoreReverseCharge = (count) => {
  if (count === 0) return 95;
  if (count <= 2) return 78;
  if (count <= 5) return 55;
  return clamp(55 - (count - 5) * 5, 20, 55);
};

const scoreFiling = (consistency) => clamp(consistency * 0.95, 0, 98);

export const scoreD8 = (inputs) => {
  const categoryMix = scoreCategoryMix(inputs.standardRatedShare);
  const exempt = scoreExempt(inputs.exemptShare);
  const reverseCharge = scoreReverseCharge(inputs.reverseChargeAnomalies);
  const filing = scoreFiling(inputs.filingConsistency);

  const score = blend([
    { score: categoryMix, weight: 0.3 },
    { score: exempt, weight: 0.2 },
    { score: reverseCharge, weight: 0.2 },
    { score: filing, weight: 0.3 },
  ]);

  return { score, subScores: { categoryMix, exempt, reverseCharge, filing } };
};
